/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2026
///                                     RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import InProgressBannerContent from "./InProgressBannerContent";
import messages from "../../../helpers/messages";

function ImportProgressState() {
  return (
    <InProgressBannerContent
      message={messages.laneInImportProgressBannerMessage.defaultMessage}
    />
  );
}

export default ImportProgressState;
